import { useCallback } from 'react';
import { useCases } from '../../../core/di/useCases';
import { useAuth } from '../../../core/providers/AuthProvider';

export const useFollowRequests = () => {
  const { user: currentUser, refreshUser } = useAuth();

  const acceptFollowRequest = useCallback(async (requesterId) => {
    await useCases.acceptFollowRequest.execute(currentUser.uid, requesterId);
    if (refreshUser) await refreshUser();
  }, [currentUser, refreshUser]);

  const rejectFollowRequest = useCallback(async (requesterId) => {
    await useCases.rejectFollowRequest.execute(currentUser.uid, requesterId);
    if (refreshUser) await refreshUser();
  }, [currentUser, refreshUser]);

  return { acceptFollowRequest, rejectFollowRequest };
}; 